import React from "react";
import ContextMenuWrapper from "./common/ContextMenuWrapper.jsx";
import ToolTip from "./common/ToolTip";
import IncrDecrSimple from "./common/IncrDecrSimple.jsx";
import Toggle from "react-toggle";
import "react-toggle/style.css";

class HistoGramContextMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.getHistState();
        this.subscriptions = [];
    }

    componentDidMount() {
        this.props.Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:modelUpdated", (/*data*/) => {
            // update all states in response to plot update. e.g. handleChangeAxis() causes both axis and bin option changes.
            this.setState( this.getHistState());
            //TODO: need to update binSize default value in state
        });
    }

    componentWillUnmount = () => {
        this.props.Dyn.mediatorLocalRemoveAll( this.subscriptions );
    }

    handleChangeAxis = (e) => {
        // update plot to new axis setting; triggers this.state update via "plot:modelUpdated" notification.
        e.stopPropagation();
        let axisType = e.target.value;
        this.props.handleChange( { change:"axisType", axisType:axisType });
    };

    handleChangeBinOptions = (e, binType ) => {
        // update plot to new bin setting; triggers this.state update via "plot:modelUpdated" notification.
        e.stopPropagation();
        this.props.handleChange( { change:"binType", binType:binType /*, wantOn:wantOn*/ });
    };

    getHistState = () => {
        // update the axis and bin options to match the current plot
        let Dyn = this.props.Dyn,
            plotElement = Dyn.plotView.plotShaper.findElement( Dyn.EPlotControl.kControlsHistogram ),
            newState = this.props.getHistState( plotElement );
        //console.log( "HistoGramContextMenu.handlePlotUpdate", newState );
        return newState;
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc(str);
    };

    render = () => {
        let { Dyn } = this.props;
        return (
            <ContextMenuWrapper {...this.props} isColorPickerEnable={true}>
                <ContextMenuWrapper.Options>
                    <div role="group" aria-labelledby="histogramAxisScaleOptions">
                        <p id="histogramAxisScaleOptions" className="tde-p-2 ted-pl-1 tde-mb-1 tde-mt-2 tde-ml-1 tde-m-0 tde-font-weight-bold">
                            {this.getLoc("Histogram Axis Scale")}
                        </p>

                        <div className={`tde-p-2 tde-std-dev-option ${this.state.axisType === "freq" ? 'active': ''}`}>
                            <label className="tde-d-flex tde-flex-items-center">
                                <input
                                    aria-label={this.getLoc("Frequency Axis")}
                                    className="tde-radio"
                                    id="tde-histogram-frequency-axis"
                                    autoFocus
                                    type="radio"
                                    name="histo"
                                    value="freq"
                                    checked={this.state.axisType === "freq"}
                                    onChange={this.handleChangeAxis}
                                />
                                {this.getLoc("Frequency Axis")}
                            </label>
                        </div>
                        <div
                            className={`tde-p-2 tde-std-dev-option ${this.state.axisType === "perc" ? 'active': ''}`}
                        >
                            <label className="tde-d-flex tde-flex-items-center">
                                <input
                                    aria-label={this.getLoc("Relative Percentage Axis")}
                                    className="tde-radio"
                                    id="tde-histogram-relative-axis"
                                    type="radio"
                                    name="histo"
                                    value="perc"
                                    checked={this.state.axisType === "perc"}
                                    onChange={this.handleChangeAxis}
                                />
                                {this.getLoc("Relative Percentage Axis")}
                            </label>
                        </div>
                        <div className={`tde-p-2 tde-std-dev-option ${this.state.axisType === "prop" ? 'active': ''}`}>
                            <label className="tde-d-flex tde-flex-items-center">
                                <input
                                    aria-label={this.getLoc("Relative Proportion Axis")}
                                    className="tde-radio"
                                    type="radio"
                                    name="histo"
                                    value="prop"
                                    id="tde-histogram-prop-axis"
                                    checked={this.state.axisType === "prop"}
                                    onChange={this.handleChangeAxis}
                                />
                                {this.getLoc("Relative Proportion Axis")}
                            </label>
                        </div>
                    </div>
                    <div className="tde-border-top tde-my-2"></div>
                    <div role="group" aria-labelledby="histogramOptions">
                        <p id="histogramOptions" className="tde-p-2 tde-ml-1 tde-m-0 tde-font-weight-bold">
                            {this.getLoc("Histogram Bin Options")}
                        </p>
                        <div className="tde-px-1 tde-pb-1">
                            <div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                                <label className="text-normal" htmlFor="tde-histogram-count-toggle">
                                    <span className="flex-1">
                                        {this.getLoc("Count by Bin")}
                                        <ToolTip
                                            tip={this.getLoc(
                                                "Display the count by Histogram bin"
                                            )}
                                            Dyn={Dyn}
                                        >
                                            <i className="tde-i tde-i-exclamation tde-ml-2" aria-label={this.getLoc(
                                                "Display the count by Histogram bin"
                                            )}></i>
                                        </ToolTip>
                                    </span>
                                </label>
                                <Toggle
                                    aria-label={`${this.getLoc("Count by Bin")}, ${this.state.binOptions.binCount ? 'checked' : 'unchecked'}, checkbox`}
                                    id="tde-histogram-count-toggle"
                                    className="black-toggle"
                                    checked={this.state.binOptions.binCount}
                                    icons={false}
                                    onChange={(e) => {
                                        this.handleChangeBinOptions( e, "binCount" );
                                    }}
                                />
                            </div>
                            <div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                                <label className="text-normal" htmlFor="tde-histogram-percent-toggle">
                                    <span className="flex-1">
                                        {this.getLoc("Percent by Bin")}
                                        <ToolTip
                                            tip={this.getLoc(
                                                "Display the percentage by Histogram bin"
                                            )}
                                            Dyn={Dyn}
                                        >
                                            <i className="tde-i tde-i-exclamation tde-ml-2" aria-label={this.getLoc(
                                                "Display the percentage by Histogram bin"
                                            )}></i>
                                        </ToolTip>
                                    </span>
                                </label>
                                <Toggle
                                    aria-label={`${this.getLoc("Percent by Bin")}, ${this.state.binOptions.binPercent ? 'checked' : 'unchecked'}, checkbox`}
                                    className="black-toggle"
                                    id="tde-histogram-percent-toggle"
                                    checked={this.state.binOptions.binPercent}
                                    icons={false}
                                    onChange={(e) => {
                                        this.handleChangeBinOptions( e, "binPercent" );
                                    }}
                                />
                            </div>
                            <div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                                <label className="text-normal" htmlFor="tde-histogram-prop-toggle">
                                    <span className="flex-1">
                                        {this.getLoc("Proportion by Bin")}
                                        <ToolTip
                                            tip={this.getLoc(
                                                "Display the proportion by Histogram bin"
                                            )}
                                            Dyn={Dyn}
                                        >
                                            <i className="tde-i tde-i-exclamation tde-ml-2" aria-label={this.getLoc(
                                                "Display the proportion by Histogram bin"
                                            )}></i>
                                        </ToolTip>
                                    </span>
                                </label>
                                <Toggle
                                    aria-label={`${this.getLoc("Proportion by Bin")}, ${this.state.binOptions.binProportion ? 'checked' : 'unchecked'}, checkbox`}
                                    id="tde-histogram-prop-toggle"
                                    className="black-toggle"
                                    checked={this.state.binOptions.binProportion}
                                    icons={false}
                                    onChange={(e) => {
                                        this.handleChangeBinOptions( e, "binProportion" );
                                    }}
                                />
                            </div>

                            <div className="tde-p-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                                <label className="text-normal" htmlFor="tde-number-of-bins">
                                    <span className="flex-1">
                                        {this.getLoc("Number of Bins")}
                                        <ToolTip
                                            tip={this.getLoc(
                                                "Increase or decrease number of bins"
                                            )}
                                            Dyn={Dyn}
                                        >
                                            <i className="tde-i tde-i-exclamation tde-ml-2" aria-label={this.getLoc(
                                                "Increase or decrease number of bins"
                                            )}></i>
                                        </ToolTip>
                                    </span>
                                </label>
                                <IncrDecrSimple
                                    id="tde-number-of-bins"
                                    label={"Number of Bins"}
                                    onIncr={() =>
                                        this.props.Dyn.mediator.publish(
                                            "axis:clickButton",
                                            { type: "plusButton" }
                                        )
                                    }
                                    onDecr={() => {
                                        this.props.Dyn.mediator.publish(
                                            "axis:clickButton",
                                            { type: "minusButton" }
                                        );
                                    }}
                                    getLoc={this.getLoc}
                                ></IncrDecrSimple>
                            </div>
                        </div>
                    </div>
                </ContextMenuWrapper.Options>
            </ContextMenuWrapper>
        );
    };
}

export default HistoGramContextMenu;
